(() => {
  function initializeDirectory(root) {
    if (root.dataset.directoryInitialized) return;
    root.dataset.directoryInitialized = 'true';
    const city = root.querySelector('[data-fr-search-city]');
    const team = root.querySelector('[data-fr-search-team]');
    const cards = [...root.querySelectorAll('[data-fr-campaign]')];
    const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
    const update = () => {
      const cityQuery = normalize(city.value), teamQuery = normalize(team.value);
      let count = 0;
      cards.forEach(card => {
        const visible = normalize(card.dataset.frCity).includes(cityQuery) && normalize(card.dataset.frTeam).includes(teamQuery);
        card.hidden = !visible; if (visible) count++;
      });
      root.querySelector('[data-fr-search-status]').textContent = cards.length ? `${root.dataset.resultLabel}: ${count}` : '';
      root.querySelector('[data-fr-no-results]').hidden = !cards.length || count > 0;
    };
    city.addEventListener('input', update); team.addEventListener('input', update); update();
  }
  document.querySelectorAll('[data-fr-directory]').forEach(initializeDirectory);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-fr-directory]').forEach(initializeDirectory));
})();
